/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTv: {
  name: 'tv';
  data: string;
} = {
  name: 'tv',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.354.646a.5.5 0 1 0-.708.708L6.793 3.5H3A1.5 1.5 0 0 0 1.5 5v9A1.5 1.5 0 0 0 3 15.5h10a1.5 1.5 0 0 0 1.5-1.5V5A1.5 1.5 0 0 0 13 3.5H9.207l2.147-2.146a.5.5 0 0 0-.708-.708L8 3.293 5.354.646ZM8 4.5H3a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5H8Z" fill="currentColor"/></svg>`,
};
